import axios from 'axios';
import _ from 'lodash';

const HttpClient = axios.create({
    baseURL: `/api/`,
});

const source = { cancel: _.noop };

// eslint-disable-next-line import/prefer-default-export
export { HttpClient, source };
